module.exports = __webpack_public_path__ + "img/green-save.svg";